/* eslint-disable import/no-anonymous-default-export */
import { CREATESTATICINFO, UPDATESTATICINFO } from "../constants/actionTypes";

export default (storeInfo = {}, action) => {
  switch (action.type) {
    case CREATESTATICINFO:
      return action.data;
    case UPDATESTATICINFO:
      return action?.payload;
    default:
      return storeInfo;
  }
};
